import React from "react";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { Link } from "react-router-dom";
import { url } from "../../Config/Config";
import { UserLogoutAction } from "../../Redux/Actions/AuthAction";

function Header() {
  const dispatch = useDispatch<any>();
  const { user_login_data } = useSelector(
    (state: any) => state?.UserLoginDataState
  );
  const fullname =
    user_login_data?.fullname ||
    [user_login_data?.first_name, user_login_data?.last_name]
      .filter(Boolean)
      .join(" ") ||
    "";
  const email = user_login_data?.email || "";

  const handleLogout = () => {
    Swal.fire({
      title: "Are you sure?",
      text: "You want to logout.",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes",
    }).then((result) => {
      if (result.isConfirmed) {
        dispatch(UserLogoutAction({}));
      }
    });
  };

  return (
    <>
      <header className="topbar">
        <nav className="navbar top-navbar navbar-expand-md navbar-dark">
          <div className="navbar-header">
            {/* This is for the sidebar toggle which is visible on mobile only */}
            <a
              className="col-md-nav-toggler waves-effect waves-light d-block d-md-none"
              href="javascript:void(0)"
            >
              <i className="ri-close-line fs-6 ri-menu-2-line" />
            </a>
            {/* ============================================================== */}
            {/* Logo */}
            {/* ============================================================== */}
            <div className="navbar-brand col-md-8 px-4">
              <Link to={url + "/"} className="logo">
                <span className="logo-text ">
                  <h5
                    className="light-logo mt-1"
                    style={{
                      color: "white",
                      fontWeight: "bolder",
                      fontSize: "20px",
                    }}
                  >
                    BrewAdmin
                  </h5>
                </span>
              </Link>
              <a
                className="sidebartoggler d-none d-md-block col-md-2"
                href="javascript:void(0)"
                data-sidebartype="mini-sidebar"
              >
                <i className="mdi mdi-toggle-switch mdi-toggle-switch-off fs-6" />
              </a>
            </div>

            <a
              className="topbartoggler d-block d-md-none waves-effect waves-light"
              href="javascript:void(0)"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i data-feather="more-horizontal" className="feather-sm" />
            </a>
          </div>

          <div
            className="navbar-collapse collapse"
            id="navbarSupportedContent"
            style={{ color: "black" }}
          >
            <ul className="navbar-nav me-auto">
              <li className="nav-item search-box">
                <a
                  className="nav-link waves-effect waves-dark"
                  href="javascript:void(0)"
                >
                  <div
                    className="d-flex align-items-center"
                    style={{ color: "black" }}
                  >
                    <i data-feather="search" className="feather-sm me-1" />
                    <div className="ms-1 d-none d-sm-block">
                      <span>Search</span>
                    </div>
                  </div>
                </a>
                <form className="app-search position-absolute">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search & enter"
                  />
                  <a className="srh-btn">
                    <i data-feather="x" className="feather-sm" />
                  </a>
                </form>
              </li>
            </ul>
            <ul className="navbar-nav">
              <li className="nav-item dropdown"></li>
              <li className="nav-item dropdown border-end">
                <div
                  className="
              dropdown-menu dropdown-menu-end
              mailbox
              dropdown-menu-animate-up
            "
                >
                  <span className="with-arrow">
                    <span className="bg-primary" />
                  </span>
                </div>
              </li>
              {/* ============================================================== */}
              {/* End Comment */}
              {/* ============================================================== */}
              {/* ============================================================== */}
              {/* User profile and search */}
              {/* ============================================================== */}
              <li className="nav-item dropdown">
                <a
                  className="
              nav-link
              dropdown-toggle
              waves-effect waves-dark
              pro-pic
            "
                  href=""
                  data-bs-toggle="dropdown"
                  aria-haspopup="true"
                  aria-expanded="false"
                >
                  <i
                    className="mdi mdi-account-circle"
                    style={{ color: "#0555c8", fontSize: "28px" }}
                  ></i>
                  {/* {userAuthenticate?
                  <>
                    <span className="ms-1 font-weight-medium" style={{color:"black"}}>
                     {fullname}
                    <i data-feather="chevron-down" className="feather-sm" />
                  </span>
                  </>:<></>} */}
                </a>
                <div
                  className="
              dropdown-menu dropdown-menu-end
              user-dd
              animated
              flipInY
            "
                >
                  <span className="with-arrow">
                    <span className="bg-primary" />
                  </span>
                  <div
                    className="
                d-flex
                no-block
                align-items-center
                justify-content-center pt-4 py-3
                mb-2
              "
                    style={{ borderBottom: "1px solid #e9ecef" }}
                  >
                    <div className="ms-2 text-center">
                      <h4 className="mb-0 fs-12px fw-bold">
                        {" "}
                        {fullname}
                      </h4>
                      <p className="mb-0 fs-10px text-secondary">
                        {" "}
                        {email}
                      </p>
                    </div>
                  </div>
                  <ul className="list-unstyled py-2">
                    {/* <li className="dropdown-item py-2">
                      <a
                        href="../../pages/general/profile.html"
                        className="text-body ms-0"
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-user me-2 icon-md"
                        >
                          <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path>
                          <circle cx="12" cy="7" r="4"></circle>
                        </svg>
                        <span>Profile</span>
                      </a>
                    </li>
                    <li className="dropdown-item py-2">
                      <a href="javascript:;" className="text-body ms-0">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-edit me-2 icon-md"
                        >
                          <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
                          <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
                        </svg>
                        <span>Edit Profile</span>
                      </a>
                    </li> */}

                    <li className="dropdown-item py-2">
                      <a onClick={handleLogout} className="text-body ms-0">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="18"
                          height="18"
                          viewBox="0 0 24 24"
                          fill="none"
                          stroke="currentColor"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          className="feather feather-log-out me-2 icon-md"
                        >
                          <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
                          <polyline points="16 17 21 12 16 7"></polyline>
                          <line x1="21" y1="12" x2="9" y2="12"></line>
                        </svg>
                        <span>Log Out</span>
                      </a>
                    </li>
                  </ul>
                </div>
              </li>
              {/* ============================================================== */}
              {/* User profile and search */}
              {/* ============================================================== */}
            </ul>
          </div>
        </nav>
      </header>
    </>
  );
}

export default Header;
